module.exports = __webpack_public_path__ + "static/media/editorial-tiny.61295e34.jpg";